import React from 'react';
import _ from 'lodash';
import { useSelector } from 'store/hooks';
import { WidgetT } from 'routes/Dashboard/components/WidgetsLayout/helpers';
import PrintablePage from './PrintablePage';
import {
    getWidgetsAndDuplicatesByPage,
    PrintableWidget,
} from './helpers/paginationHelpers';
import './_printableGrid.scss';

type Props = {
    title: string;
    widgets: WidgetT[];
    WidgetRender: (arg1: {
        widget: WidgetT | PrintableWidget;
    }) => React.ReactElement;
    filters: DashboardFilterT[];
};

/*
 * Printable version of dashboards.
 *
 * How does it work ?
 *
 * This component is split into a succession of `PrintablePage`s, each one of them
 * corresponding exactly to one page in the printed document (in A4 format).
 *
 * In order to achieve this, we group the children (ie the widgets) according to
 * the page to which they belong, based on their `y` RGL coordinate.
 * Note: we always use the `md` RGL layout here.
 *
 * If a widget goes beyond the vertical limit of its page, the overflow is hidden.
 * In order to help the user avoid this, there exists a PrintPaginationSeparators component,
 * which is a visual indication of the page limits displayed to the user in
 * the dashboard edition mode.
 *
 * BEWARE: modifying this component can break the validity of PrintPaginationSeparators.
 * If it happens, you have to modify the constants in the constants file.
 */
const PrintableGrid = (props: Props): React.ReactElement => {
    const client = useSelector((vision) => vision.vision.client);

    const widgetsAndDuplicatesByPage = getWidgetsAndDuplicatesByPage(
        props.widgets,
    );
    // NOTE: pay attention, the class .printable-root is used by the backend (dashboard_export endpoint)
    return (
        <div className="printable-root">
            {Object.keys(widgetsAndDuplicatesByPage).map((index) => (
                <PrintablePage
                    key={index}
                    pageIndex={_.toNumber(index)}
                    pageWidgets={widgetsAndDuplicatesByPage[index]}
                    WidgetRender={props.WidgetRender}
                    clientLogoUrl={client.logoUrl}
                    title={props.title}
                    filters={props.filters}
                />
            ))}
        </div>
    );
};

export default PrintableGrid;
